// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICopayGroupDto } from './ICopayGroupDto';
import {
    ICopayGroupDtoFromJSON,
    ICopayGroupDtoFromJSONTyped,
    ICopayGroupDtoToJSON,
    ICopayGroupDtoToJSONTyped,
} from './ICopayGroupDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageCopayGroupDto
 */
export interface IPageCopayGroupDto {
    /**
     * 
     * @type {number}
     * @memberof IPageCopayGroupDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageCopayGroupDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageCopayGroupDto
     */
    size?: number;
    /**
     * 
     * @type {Array<ICopayGroupDto>}
     * @memberof IPageCopayGroupDto
     */
    content?: Array<ICopayGroupDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageCopayGroupDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageCopayGroupDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageCopayGroupDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageCopayGroupDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageCopayGroupDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageCopayGroupDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageCopayGroupDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageCopayGroupDto interface.
 */
export function instanceOfIPageCopayGroupDto(value: object): value is IPageCopayGroupDto {
    return true;
}

export function IPageCopayGroupDtoFromJSON(json: any): IPageCopayGroupDto {
    return IPageCopayGroupDtoFromJSONTyped(json, false);
}

export function IPageCopayGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageCopayGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(ICopayGroupDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageCopayGroupDtoToJSON(json: any): IPageCopayGroupDto {
    return IPageCopayGroupDtoToJSONTyped(json, false);
}

export function IPageCopayGroupDtoToJSONTyped(value?: IPageCopayGroupDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(ICopayGroupDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

